import { Component, Input, ViewChild } from "@angular/core";
import { CBP3461 } from "../../../../objects/documents/CBP3461";
import { ValidationPatterns } from "../../../../common/helpers/ValidationPatterns";
import { NgForm } from "@angular/forms";

@Component({
    selector: 'bill-of-landing-3461',
    templateUrl: "bill-of-landing-3461.component.html",
    moduleId: module.id.toString()
})
export class BillOfLanding3461Component {
    @Input()
    public document: CBP3461;

    public numberPatternHelper = ValidationPatterns;

    @ViewChild("billOfLandingForm")
    public billOfLandingForm: NgForm;


    public isFormValid(): boolean {
        return this.billOfLandingForm.valid;
    }

    public submitFormAndValidity(): boolean {
        this.billOfLandingForm.onSubmit(null);

        return this.isFormValid();
    }
}


// WEBPACK FOOTER //
// ./app/components/export-documents/cbp-3461/document-blocks/bill-of-landing-3461.component.ts